import { useCallback } from 'react'
import { useBuyButton } from 'src/components/restructure/product/sections/Sidebar/ProductAction/BuyButton/hooks/useBuyButton'
import type { ProductItem } from 'src/components/restructure/product/types/productItem'
import type { KitlookData } from 'src/types/kitlooks'

interface SelectedProduct {
  productId: string
  skuId: string
  isSelected: boolean
}

interface UseKitlookActionsProps {
  currentKit: KitlookData | null
  selectedProducts: SelectedProduct[]
}

type KitlookActionType = 'addToCart' | 'buyNow'

export const useKitlookActions = ({
  currentKit,
  selectedProducts,
}: UseKitlookActionsProps) => {
  const { addToCart } = useBuyButton({
    propCurrentSku: currentKit?.products[0]?.items[0] as ProductItem,
  })

  const handlePurchase = useCallback(
    async (actionType: KitlookActionType = 'addToCart') => {
      if (!currentKit) return

      const itemsToBuy = currentKit.products
        .filter((product) => {
          const selection = selectedProducts.find(
            (p) => p.productId === product.productId
          )

          return selection?.isSelected
        })
        .map((product, index) => {
          const selection = selectedProducts.find(
            (p) => p.productId === product.productId
          )

          if (!selection) return null

          const selectedItemData = product.items.find(
            (item) => item.itemId === selection.skuId
          )

          const seller = selectedItemData?.sellerDefault

          return {
            id: selection.skuId,
            productId: product.productId,
            seller: seller?.sellerId ?? '1',
            quantity: 1,
            index,
            price: seller?.sellerOffer?.cashPrice ?? 0,
          }
        })
        .filter(Boolean)

      if (itemsToBuy.length === 0) {
        return
      }

      await addToCart({
        item: itemsToBuy as any,
        type: actionType,
        shouldOpenFeedback: actionType === 'addToCart',
        origin: 'kitlook_confirmation_modal',
      })
    },
    [currentKit, selectedProducts, addToCart]
  )

  return {
    handlePurchase,
  }
}
